import { filterEmptyParams, isObjectEmpty } from './formatObject'

/**
 *  对象数组去重
 */
export function uniqueArrayData(arrList) {
  let obj = {}
  arrList = arrList.reduce((cur, next) => {
    obj[next.id] ? '' : (obj[next.id] = true && cur.push(next))
    return cur
  }, [])
  return arrList
}

/**
 *  判断数组中所有对象的值不为空
 */
export function hasNotValueEmpty(arrList, ignoreKey) {
  if (!arrList || arrList.length === 0) return true
  const allValuesNotEmpty = arrList.every((obj) => {
    for (let key in obj) {
      const value = obj[key]
      if (ignoreKey.includes(key)) break
      if (
        value === '' ||
        value === null ||
        (Array.isArray(value) && value.length === 0) ||
        JSON.stringify(value) === `{}`
      ) {
        return false
      }
    }
    return true
  })
  return allValuesNotEmpty
}
